import * as React from "react";
import {useEffect} from "react";
import {RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import {applyUrl, imageBaseUrl} from "config";
import "./styles.scss";

interface IConnectProps {
    dispatch?: (action: any) => void;
    isAndroid: boolean;
}
const razorpayUrlParams = new URLSearchParams(`?${window.location.hash.split("?")[1]}`);
const msg = {
    EGOLD: "View your order status",
    INSURANCE: "Your insurance will be issued in 24hrs.",
};
const productName: string | null = razorpayUrlParams.get("product");
const transactionId: string | null = razorpayUrlParams.get("transaction_id");
const transactionType: string | null = razorpayUrlParams.get("txn_type");

const getRedirectionUrl = (isAndroid, productName) => {
    const redirectLinks = {
        EGOLD: `${applyUrl}#/${isAndroid ? "android/" : ""}egold/orderDetails?transaction_id=${transactionId}&txn_type=${transactionType}&paymentComplete=true`,
        INSURANCE: `${applyUrl}#/android/insurance/activeInsurances`,
    };
    return redirectLinks[productName];
}

function PaymentSuccess(props: IConnectProps & RouteComponentProps) {
    useEffect(() => {
        if (props.isAndroid) {
            (window as any).Android.notify("CLEAR_WEBVIEW_STACK", JSON.stringify({}));
        }
    }, []);
    function handleClickViewStatus() {
        window.location.href = getRedirectionUrl(props.isAndroid, productName);
    }
    return (
            <div className="order-payment-success">
                <div className="text-center">
                    <img src={`${imageBaseUrl}/img/icons/eGold/Successful.png`} width={120}/>
                    <h5 className="mt-3">Payment Successful</h5>
                    <span className="d-block ">
                        <p style={{fontSize: "12px"}} className="px-2">
                            {msg[productName] && msg[productName]}
                        </p>
                    </span>
                    <button className="pt-2 mt-4 eGold-submit-btn"
                            onClick={() => handleClickViewStatus()}
                    >
                        View Order
                    </button>
            </div>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        isAndroid: state.login.isAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(PaymentSuccess);
